import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import { MetaTags } from '@/components/seo/meta-tags';
import { Link } from 'wouter';

export default function NotFound() {
  return (
    <>
      <MetaTags
        title="Page Not Found - 7Sigma"
        description="The page you're looking for doesn't exist. Navigate back to discover 7Sigma's technology consulting and innovation services."
      />
      <div className="min-h-[calc(100vh-300px)] flex items-center justify-center">
        <Card className="w-full max-w-md mx-4 bg-slate-900/80 border-slate-800 shadow-xl">
          <CardContent className="p-8 md:p-12 text-center">
            <h1 className="text-7xl md:text-8xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-6">
              404
            </h1>
            <h2 className="text-2xl font-semibold text-white mb-4">Page Not Found</h2>
            <p className="text-gray-400 mb-8 text-lg">
              The page you're looking for doesn't exist or has been moved.
            </p>

            <Link href="/">
              <Button
                size="lg"
                className="flex items-center gap-2 mx-auto bg-blue-600 hover:bg-blue-700"
              >
                <Home className="h-5 w-5" />
                Return Home
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
